export const ROOT_PATH = 'brand-voice'

export const keys = {
  list: (accountId: string) => [ROOT_PATH, 'list', accountId],
}
